@if (visible) {
    <div class="name-section">
        @if (!editing) {
            <!-- Read-only: compact single line, click the pencil or double-click the name to edit -->
            <div class="name-display" (dblclick)="startEdit()" [title]="label">
                <span class="name-text">{{ label || ('placeholder.name' | transloco) }}</span>
                <mat-icon class="name-edit-icon" (click)="startEdit()"
                          [attr.aria-label]="'general.edit' | transloco">edit</mat-icon>
            </div>
        } @else {
            <!-- Edit mode: Enter/blur commits, Esc cancels -->
            <div class="name-edit">
                <input #nameInput inputrestriction="basic1" autocomplete="off" type="text"
                       [value]="label" class="name-input"
                       (keydown.enter)="nameInput.blur()"
                       (keydown.escape)="cancelEdit()"
                       (blur)="commitEdit(nameInput.value)" />
            </div>
        }
    </div>
}
